module.exports = __webpack_public_path__ + "static/media/l.83ff7a11.png";